var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationLimitFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77344 13L4.77344 14L6.77344 14L6.77344 13L5.77344 13L4.77344 13ZM6.77344 10L11.5469 -2.52368e-07L-6.58949e-05 2.52368e-07L4.77344 10L6.77344 10ZM5.77344 13L6.77344 13L6.77344 9L5.77344 9L4.77344 9L4.77344 13L5.77344 13Z",
    fill: "#00703E",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationLimitFlag);
export default __webpack_public_path__ + "static/media/reservation-limit-flag.70d5f743241d29a581e8a3bec0493f72.svg";
export { ForwardRef as ReactComponent };